import { render, staticRenderFns } from "./ShiftViewInfo.vue?vue&type=template&id=a74441a4&"
import script from "./ShiftViewInfo.vue?vue&type=script&lang=js&"
export * from "./ShiftViewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports